import styled, { css } from 'styled-components/macro'

import { settings } from '../../../styled/settings/index';
import { mixins } from '../../../styled/mixins/index';

const {
  colors: { color, hexToRGBa },
  mediaqueries: { mobileDown, tabletLandscapeDown, tabletPortraitDown },
  sizing: { fontsize, spacingsize, radiussize },
  shadows: { buttonShadowDefault },
} = settings;

const {
  layout: { centered, centeredContent, pageSection, pageSectionInner },
  typography: { buttonText, heading1, heading2, heroDescription },
} = mixins;

export const PageHeroContainer = styled.section`
  ${pageSection}
  color: ${(props) => props.fontColor ? color(props.fontColor) : color(`white`)};
  position: relative;
`;

export const PageHeroInnerContainer = styled.div`
  ${pageSectionInner}
`;

export const PageHeroLogoContainer = styled.div`
  /* width: 100vw; */
`;

export const PageHeroLogo = styled.img`
  margin: 0 auto;
  display: table;
  height: 14.0625rem;

  @media ${tabletLandscapeDown} {
    height: 10rem;
  }

  @media ${tabletPortraitDown} {
    height: 10rem;
  }

  @media ${mobileDown} {
    height: 6rem;
  }
`;

export const PageHeroContentContainer = styled.div`
  display: flex;
  align-items: center;

  /* stylelint-disable comment-empty-line-before */
  ${(props) => (props.isPageHero) && css`
    min-height: 60vh;
  `}
  /* stylelint-enable */
`;

export const PageHeroContentInnerContainer = styled.div`
  display: table;
  margin: 0 auto;
`;

export const PageHeroTitle = styled.h1`
  ${heading1}
  text-align: center;
  text-transform: uppercase;
  padding: 3rem;
  line-height: 1;

  /* remove the padding from the injected <p> element from rendering markdown */
  p {
    padding: 0;
    margin: 0;
  }

  /* stylelint-disable comment-empty-line-before */
  ${(props) => (props.titleColor) && css`
    color: ${color(props.titleColor)};
  `}

  ${(props) => (props.titleBackgroundColor && props.titleBackgroundColor !== `clear`) && css`
    background-color: ${color(props.titleBackgroundColor)};
  `}
  /* stylelint-enable */
`;

export const PageHeroSubtitle = styled.h3`
  ${heading2}
  text-align: center;
  text-transform: uppercase;
`;

export const PageHeroDescription = styled.p`
  ${centeredContent}
  ${heroDescription}
  max-width: 50vw;

  @media ${tabletLandscapeDown} {
    max-width: 65vw;
  }

  @media ${tabletPortraitDown} {
    max-width: 80vw;
  }

  @media ${mobileDown} {
    max-width: 85vw;
  }
`;